'use client';

import React from 'react';

import { TasticProps } from '../types';
import OccasionBannerCard from 'components/commercetools-ui/organisms/occasion-banner';

const OccasionBannerTastic = ({ data }: TasticProps<any>) => {
  const { imageSrc, title, target, ctaText } = data;
  if (imageSrc && title && (!target || !!ctaText)) {
    return <OccasionBannerCard {...data} />;
  }
  return null;
};

export default OccasionBannerTastic;
